import { useTranslation } from "react-i18next";
import { TiArrowBackOutline } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import css from "./Forbidden.module.css";
import nodata from "../../assets/images/Forbidden.svg";

function Forbidden() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className={css.noSpacesContainer}>
      <div className={css.noSpacesDataContainer}>
        <img src={nodata} alt="Forbidden 403" className={css.noSpacesImg} />
      </div>
      <div className={css.headingContainer}>
        <span className={css.headText}>{t("Sorry!")}</span>
        <span>{t("You do not have access to this page")}</span>
      </div>
      <button type="submit" className={css.goBackButton} onClick={goBack}>
        <TiArrowBackOutline size={20} className={css.goBackIcon} /> Go back
      </button>
    </div>
  );
}

export default Forbidden;
